var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusErrorIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "colored",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12.8471 14.1654L13.0272 7.54541H10.9728L11.1575 14.1654H12.8471ZM11.2175 16.7968C11.436 17.0123 11.6976 17.12 12.0023 17.12C12.2978 17.12 12.5547 17.0123 12.7733 16.7968C12.9948 16.5814 13.1072 16.3198 13.1103 16.012C13.1072 15.7104 12.9948 15.4519 12.7733 15.2365C12.5547 15.021 12.2978 14.9133 12.0023 14.9133C11.6976 14.9133 11.436 15.021 11.2175 15.2365C10.999 15.4519 10.8913 15.7104 10.8944 16.012C10.8913 16.3198 10.999 16.5814 11.2175 16.7968Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusErrorIcn);
export default __webpack_public_path__ + "static/media/status-error-icn.6a8822502df1558d6f2a167ded486c36.svg";
export { ForwardRef as ReactComponent };